import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/$id/versions")({
  staticData: {
    title: "versions.title",
  },
});
